// extracted by mini-css-extract-plugin
module.exports = {"switch":"InstrumentalFilter_switch__MyACQ"};